const GUEST_SHOPPING_CART_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function getStorage(storage = null) {
  if (storage) {
    return storage;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}

export function isGuestShoppingCartId(value) {
  return typeof value === 'string' && GUEST_SHOPPING_CART_ID_PATTERN.test(value);
}

export function getGuestShoppingCartId(stateValue = null, storage = null) {
  const targetStorage = getStorage(storage);
  let storedValue = null;

  try {
    storedValue = targetStorage ? targetStorage.getItem('shopping_cart_id') : null;

    if (storedValue !== null && !isGuestShoppingCartId(storedValue)) {
      targetStorage.removeItem('shopping_cart_id');
      storedValue = null;
    }
  } catch (error) {
    storedValue = null;
  }

  if (isGuestShoppingCartId(stateValue)) {
    return stateValue;
  }

  return isGuestShoppingCartId(storedValue) ? storedValue : null;
}

export function clearGuestShoppingCartId(storage = null) {
  const targetStorage = getStorage(storage);

  try {
    if (targetStorage) {
      targetStorage.removeItem('shopping_cart_id');
    }
  } catch (error) {
    // Storage can be blocked; in-memory validation still protects requests.
  }
}

export function persistGuestShoppingCartId(value, storage = null) {
  const targetStorage = getStorage(storage);

  if (!isGuestShoppingCartId(value)) {
    clearGuestShoppingCartId(targetStorage);
    return false;
  }

  try {
    if (targetStorage) {
      targetStorage.setItem('shopping_cart_id', value);
    }
  } catch (error) {
    // Keep the valid ID in Vuex even when browser storage is unavailable.
  }

  return true;
}
